module.exports = __webpack_public_path__ + "static/media/nr.4ffb5239.svg";